import { Box, CircularProgress, Typography } from "@mui/material";
import { observer } from "mobx-react";

export interface CircularProgressWithContentProps {
  size?: number;
  value?: number;
  content: any;
}

const CircularProgressWithContent = observer((props: any) => {
  return (
    <Box sx={{ position: "relative", width: `${props.size || 40}px`, height: `${props.size || 40}px` }}>
      <CircularProgress
        enableTrackSlot
        variant={props.value !== undefined ? "determinate" : "indeterminate"}
        size={props.size || 40}
        value={props.value || 0}
        sx={{
          animationDuration: "5000ms",
          color: (theme) => theme.palette.info.main,
          position: "absolute",
          left: 0,
        }}
      />
      <Box
        sx={{
          top: 6,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="caption" component="div" color="textSecondary">
          {props.content}
        </Typography>
      </Box>
    </Box>
  );
});

export default CircularProgressWithContent;
